import React, { useState, useEffect } from 'react';
import { TopUpBalanceModal } from '../../../../_mexablock/partials/modals/balance/TopUpBalanceModal';
import { useSelectOffers } from '../../operacion/activacion/hooks/ActivacionHook';
import { MovInventory } from './MovInventory';
import Indicators from './Indicators';
import { GraficaBalance } from './GraficaBalance';
import { Filter } from '../../inventario/productos/components/Filter';
import { GraficaColonia } from './GraficaColonia';
import { GraficaNivel } from './GraficaNivel';
import { SimAsig } from './SimAsignadas';
import { SimAsigZona } from './SimAsignadaZona';
import { shallowEqual, useSelector } from 'react-redux';
import { UserModel } from '../../../modules/auth/models/UserModel';
import { RootState } from '../../../../setup';
import MisPlanes from './MisPlanes';

const DashboardPage: React.FC = () => {
  const user: UserModel = useSelector<RootState>(
    ({ auth }) => auth.user,
    shallowEqual
  ) as UserModel;

  const userRoles =
    (user?.roles as Array<{
      id?: number | null;
      name?: string | null;
      code?: string | null;
    }>) || [];

  // --- Fechas inicial ---
  const fechaActual = new Date();
  const fecha_inicio_init = new Date(
    fechaActual.getFullYear(),
    fechaActual.getMonth(),
    1
  );
  const fecha_fin_init = new Date();

  const [initFilterValues, setInitFilterValues] = useState({
    init_date: new Date(fecha_inicio_init).toISOString().split('T')[0],
    end_date: new Date(fecha_fin_init).toISOString().split('T')[0],
  });
  const [visivilityModal, setVisivilityModal] = useState(false);
  const [offersCache, setOffersCache] = useState<any[]>([]);
  const { data: offers, loading } = useSelectOffers(
    offersCache.length === 0,
    'recharge'
  );

  useEffect(() => {
    if (offers.length > 0 && offersCache.length === 0) {
      setOffersCache(offers);
    }
  }, [offers]);

  // --- Filtros ---
  const handleFilter = (values: any) => {
    setInitFilterValues(values);
  };

  const handleFilterClean = () => {
    setInitFilterValues({
      init_date: new Date(fecha_inicio_init).toISOString().split('T')[0],
      end_date: new Date(fecha_fin_init).toISOString().split('T')[0],
    });
  };

  const userHasRole = (rolesToCheck: string[]): boolean => {
    if (!userRoles || userRoles.length === 0) return false;

    const userRoleCodes = userRoles.map(
      (r: any) => r.code?.toUpperCase() || ''
    );

    return rolesToCheck.some((role) =>
      userRoleCodes.includes(role.toUpperCase())
    );
  };

  return (
    <>
      <div className="row w-100 gx-2 justify-content-end me-3">
        <div className="col-md-2 text-end w-125px mb-5">
          <Filter
            initFilterValues={initFilterValues}
            onCleanFilter={handleFilterClean}
            onSearchFilter={handleFilter}
          />
        </div>
      </div>

      {/* --- Rol: ADMIN o CALL_CENTER --- */}
      {userHasRole(['ADMIN_MEXABLOCK', 'CALL_CENTER']) && (
        <>
          <Indicators filterDate={initFilterValues} />
          <div className="d-flex mt-5 mb-5 justify-content-between">
            <GraficaNivel filterDate={initFilterValues} loadingGrid={false} />
            <GraficaColonia filterDate={initFilterValues} loadingGrid={false} />
          </div>
          <div className="row mb-9 mt-5">
            <div className="col-12">
              <GraficaBalance filterDate={initFilterValues} />
            </div>
          </div>
          <div className="d-flex justify-content-between mb-9 mt-5">
            <MovInventory filterDate={initFilterValues} />
            <SimAsig filterDate={initFilterValues} loadingGrid={false} />
          </div>
          <MisPlanes offers={offersCache} loading={loading} />
        </>
      )}

      {/* --- Rol: ZONA --- */}
      {userHasRole(['ZONA']) && (
        <div className="row g-6 g-xl-9">
          <SimAsigZona filterDate={initFilterValues} loadingGrid={false} />
        </div>
      )}
      <TopUpBalanceModal
        show={visivilityModal}
        handleClose={() => setVisivilityModal(!visivilityModal)}
      />
    </>
  );
};

export { DashboardPage };
